import { useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { captureException } from '@sentry/browser';
import { useChannelStateContext } from './streamHooks';
import { useProfile } from '../../../api/user/profile';
import { getProcUserId } from '../utils';
import { MARK_ROOM_HAS_REAL_MESSAGES } from '../queries/markRoomHasRealMessages';
import { MarkRoomHasRealMessages, MarkRoomHasRealMessagesVariables } from '../../../api/types/MarkRoomHasRealMessages';
import { messageTypesToNotify } from '../Message/realMessageTypes';

export const useRealMessagesListener = () => {
  const { channel } = useChannelStateContext();
  const profile = useProfile();
  const [markRoomHasRealMessages, { error }] = useMutation<
    MarkRoomHasRealMessages, MarkRoomHasRealMessagesVariables
  >(MARK_ROOM_HAS_REAL_MESSAGES);

  useEffect(() => {
    // As we don't show this error on UI we have to catch it to sentry
    if (error) {
      captureException(error);
    }
  }, [error]);

  useEffect(() => {
    const hasRealMessages = !!channel.data?.has_real_messages;
    if (hasRealMessages) {
      return;
    }

    const listener = channel.on('message.new', ({ user, message }) => {
      if (
        profile.user_id === getProcUserId(user?.id!)
        && channel.id
        && messageTypesToNotify.includes(message?.type!)
      ) {
        markRoomHasRealMessages({
          variables: { roomId: channel.id },
        });
      }
    });

    // eslint-disable-next-line consistent-return
    return () => {
      listener.unsubscribe();
    };
  }, [channel, profile, markRoomHasRealMessages]);
};
